import axios from "axios";

export class CustomerUtils {

    /**
     * 顧客情報を取得します。
     * @param callback 顧客情報取得後に実行するコールバック関数（HTTPステータスコード、顧客情報）
     */
    public static getCustomers(callback: (status: number, customers: any) => void) {
        axios.get("/customers")
            .then(cb => {
                callback(cb.status, cb.data)
            })
            .catch(error => {
                // エラーによっては、errorがメッセージ文字列となりresponseが存在しない
                const status = error.response ? error.response.status : 500;
                callback(status, null)
            });
    }
}